import { render, staticRenderFns } from "./NavItem.vue?vue&type=template&id=ea1c320e&scoped=true"
import script from "./NavItem.vue?vue&type=script&lang=js"
export * from "./NavItem.vue?vue&type=script&lang=js"
import style0 from "./NavItem.vue?vue&type=style&index=0&id=ea1c320e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1c320e",
  null
  
)

export default component.exports